import { useState } from 'react';
import { Paper, Typography, Button } from '@safedns/skydns-ui-react-lib';

import AuthKeyView from './AuthKeyView';
import Loader from '../UI/loader/Loader';
import AuthKeyCreatedDialog from './AuthKeyCreatedDialog';
import AuthKeyRegenerateDialog from './AuthKeyRegenerateDialog';
import CircularProgress from '../UI/circular-progress';

import {
  useGetUserQuery,
  useGetAuthKeyQuery,
  useDeleteAuthKeyMutation,
  useCreateAuthKeyMutation,
  useRequestAgentQuery,
} from '../../services/ADapi';

const AuthKey = () => {
  const [isDialogShow, setDialogState] = useState(false);
  const [isRegenerateDialogShow, setRegenerateDialogState] = useState(false);
  const [key, setKey] = useState('');
  const [isAuthKeyRegenerating, setAuthKeyRegeneratingState] = useState(false);

  const {
    data: { user_id },
  } = useGetUserQuery();
  const { data: authKey, isLoading, error } = useGetAuthKeyQuery(user_id);
  const [createAuthKey, { isLoading: isAuthKeyCreating }] =
    useCreateAuthKeyMutation();
  const [deleteAuthKey] = useDeleteAuthKeyMutation();
  const { data: agent } = useRequestAgentQuery(user_id);

  const isAgentBuilding = agent !== undefined && agent.status === 'Send';

  const createAuthKeyHandler = async () => {
    try {
      const res = await createAuthKey({ user_id }).unwrap();

      setKey(res.auth_key);
      setDialogState(true);
      setRegenerateDialogState(false);
    } catch (error) {
      console.error(error);
    }
  };

  // TODO: refactor this. Combine with createAuthKeyHandler
  const regenerateAuthKeyHandler = async () => {
    setAuthKeyRegeneratingState(true);

    try {
      await deleteAuthKey({ user_id }).unwrap();
      const res = await createAuthKey({ user_id }).unwrap();

      setKey(res.auth_key);
      setAuthKeyRegeneratingState(false);
      setDialogState(true);
      setRegenerateDialogState(false);
    } catch (error) {
      console.error(error);
      setAuthKeyRegeneratingState(false);
    }
  };

  const dialogStateHandler = () => {
    setDialogState((prevState) => !prevState);
  };

  const regenerateDialogStateHandler = () => {
    setRegenerateDialogState((prevState) => !prevState);
  };

  // When we delete an auth key, the next request for a key will return an error, so we check for that error too
  const isAuthKeyCreated = authKey && !error;

  return (
    <Paper title="AuthKey">
      <Typography variant="body1" sx={{ paddingBottom: 24 }}>
        Ключи генерируются на стороне сервера и отображаются только один раз.
      </Typography>
      {isLoading ? <Loader /> : null}
      {isAuthKeyCreated ? (
        <AuthKeyView isAgentBuilding={isAgentBuilding} />
      ) : null}
      <Button
        variant="secondary"
        onClick={
          isAuthKeyCreated ? regenerateDialogStateHandler : createAuthKeyHandler
        }
        isDisabled={isAuthKeyCreating || isAgentBuilding}
      >
        {isAuthKeyCreated ? 'Перевыпустить ключ' : 'Сгенерировать ключ'}
        {isAuthKeyCreating ? (
          <CircularProgress size={15} sx={{ ml: 1 }} color="white" />
        ) : null}
      </Button>
      {isDialogShow ? (
        <AuthKeyCreatedDialog
          authKey={key}
          isDialogShow={isDialogShow}
          onDialogAction={dialogStateHandler}
        />
      ) : null}
      {isRegenerateDialogShow ? (
        <AuthKeyRegenerateDialog
          isDialogShow={isRegenerateDialogShow}
          onDialogAction={regenerateDialogStateHandler}
          onCreateAction={regenerateAuthKeyHandler}
          isAuthKeyRegenerating={isAuthKeyRegenerating}
        />
      ) : null}
    </Paper>
  );
};

export default AuthKey;
